const MobileFaqs = () => {
    return(
      <div>


      <div  className="bg-[#efefef] flex justify-center items-center h-[150px]">
        <h1 className="sm:text-[40px] text-[30px] font-bold ">Frequently Asked Questions</h1>
      </div>

      <div className="flex flex-col justify-center  gap-8 max-w-[50rem] mx-auto text-center p-[3rem]">
        {/* <h1 className="sm:text-[24px] text-[20px] font-bold">Pick-up Information</h1> */}
      <div>
        {/* <div id="accordion-collapse" data-accordion="collapse"> */}

      <details>
        <summary>
          <span className="summary-title">What is TCS ‘On Call Pickup’ for corporate customers?</span>
          <div className="summary-chevron-up">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
          </div>
        </summary>

        <div className="summary-content">On Call Pickup is a TCS pickup service for corporate customers,
                available from 11am to 5pm, Monday through Saturday (for regular TCS
                  shipments). The service makes it convenient to have your shipment
              picked up from your chosen location. You can schedule an On Call
              Pickup by calling our helpline (111 123 456).
        </div>

        <div className="summary-chevron-down">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
        </div>

      </details>

      

     

        <div id="accordion-collapse" data-accordion="collapse">
            <details>
	        <summary>
            <span className="summary-title">What happens when I am not present at my address to
receive the delivery?</span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content">
          When a consignee is not available at the given address, when possible
our courier hands the shipment to the consignee’s representative present
at the address and gets a signature proof of delivery. When no one is
available at the given address, our courier leaves a message for the
consignee. After establishing contact with the consignee, the following
day our courier makes another attempt to deliver the shipment. However,
certain sensitive shipments governed by regulations can only be received
either by the consignee or their blood relative, at the provided address.
          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>


        <details>
	        <summary>
            <span className="summary-title"> Does TCS offer holiday delivery service?</span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content"> Yes, TCS delivers on holidays in the following cities: Karachi, Hyderabad,
          Sukkur, Quetta, Multan, Faisalabad, Lahore, Sialkot, Gujranwala,
          Islamabad, Rawalpindi, and Peshawar. For more details, please call:
          111 123 456.  
          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>


        <details>
	        <summary>
            <span className="summary-title"> Does TCS offer holiday delivery service for international
              shipments?</span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content">   TCS does not offer holiday service for international shipments.
          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>


        <details>
	        <summary>
            <span className="summary-title">In case of a lost shipment, will TCS compensate the
            market value of the lost goods?</span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content"> When an insured shipment is lost, TCS is liable to pay the market value
          of the lost shipment. If the shipment is not insured, the liability of TCS is
          limited as mentioned in our terms & conditions of carriage.
          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>


        <details>
	        <summary>
            <span className="summary-title"> How much does TCS charge for the insurance of high
            value goods?
          </span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content"> Commodity-wide insurance rates vary, ranging from 0.5% to 2% of
            declared value of the goods.
          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>


        <details>
	        <summary>
            <span className="summary-title"> How do I know if a shipment is dutiable?</span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content">    The regulations and the standards regarding dutiable goods vary from
          country to country. For further details, please call our helpline.
          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>


        <details>
	        <summary>
            <span className="summary-title"> If my international shipment is dutiable, will it affect the
              delivery times?
            </span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content">All shipments must go through the customs clearance procedure. This
          sometimes affect the transit times. While, it normally takes one to five
          business days for international shipments to get customs clearance,
          unusual or high-value items may take longer.
          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>


        <details>
	        <summary>
            <span className="summary-title">  What if I want to return an undelivered international
              shipment to the origin?</span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content">For all such shipments, the shipper is required to submit in writing a
            ‘Return to Origin’ (RTO) request. All return/redirection duties, taxes
            applicable at the destination, and RTO charges are payable by the
            shipper.
          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>


        <details>
	        <summary>
            <span className="summary-title">How do I claim for my lost or damaged shipment?
</span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content">All claims for international/domestic shipments must be submitted in
writing to TCS within thirty (30) days from the date that TCS accepted
the shipment. Otherwise, TCS shall not be liable for the claims.
          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>


        <details>
	        <summary>
            <span className="summary-title">What happens when an international shipment is not
delivered on the first attempt?</span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content"> In that case, the courier will automatically attempt to deliver the shipment
the next business day before 5pm. After two failed attempts, the
package is held at the local agent office until the disposal arrangements
are made.
          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>


        <details>
	        <summary>
            <span className="summary-title">Who pays duty on goods?</span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content">The consignee typically pays the duty charges. However, shipper may
also choose to pay them, by requesting for ‘Delivery Duty Paid Service’.

          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>


        <details>
	        <summary>
            <span className="summary-title">To what extent TCS is liable for shipments?</span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content">TCS operates on a limited liability basis as declared on the airway bill.
TCS liability is strictly limited to direct loss. TCS maximum liability in the
event of loss or damage to a shipment is US$ 100 or the value recorded
on the airway bill, whichever is lesser.
          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>


        <details>
	        <summary>
            <span className="summary-title"> How do I find out the domestic and international rates?
</span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content">  For domestic rates, use the ‘Rate Calculator’ on the homepage. Please
note that the rates are subject to changes.
          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>


        <details>
	        <summary>
            <span className="summary-title">Does TCS provide delivery details for all shipments?</span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content">TCS provides delivery details for all domestic shipments. For
international shipments we provide delivery status for major destinations
only. For areas which are ‘on-forwarded’ through various means or
delivered by a third-party, accurate delivery details cannot be provided.
          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>



        <details>
	        <summary>
            <span className="summary-title">What is a Tracking/Airway Bill or Consignment Note
Number?</span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content">Tracking/Airway Bill or Consignment Note Number is used by TCS to
identify and track shipments. Every shipment booked by TCS is
automatically assigned a tracking number.
          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>


        <details>
	        <summary>
            <span className="summary-title">Does TCS provide Shipment Status?</span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content">TCS provides the shipment tracking status From the moment the
shipment is picked up, till the moment it is delivered.

          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>




        <details>
	        <summary>
            <span className="summary-title">What does a status of ‘Courier Out For Delivery’ mean?</span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content">‘Courier out for Delivery’ means that your shipment is en route to be
delivered on the day.

          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>


        <details>
	        <summary>
            <span className="summary-title">What events are recorded about the Shipment?</span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content">Shipment movement information is captured each time a tracking label is
            scanned by TCS staff during transit. Common scans include:
            <p>• Shipped From</p>
            <p>• Shipped To</p>
            <p>• Shipment Date</p>
            <p>• Shipment Note</p>
            <p>• Tracking Information</p>




          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>

        <details>
	        <summary>
            <span className="summary-title">What does a detailed tracking response tell me?</span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content">A detailed tracking response will list the following information:
          <p>• The tracking number</p>
          <p>• Delivery status</p>
          <p>  • Delivery date and time </p>
          <p> • Location where the shipment was delivered</p>
          <p>  • Date on which the shipment was shipped/billed</p>
          <p>  • TCS service used to deliver the shipment</p>
          <p>  • The shipment’s weight</p>
          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>


        <details>
	        <summary>
            <span className="summary-title">How long does it take to receive an email response?</span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content">You will receive a detailed tracking response through email within 24
hours.
          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>


        <details>
	        <summary>
            <span className="summary-title">Can I track more than one shipment in a single email?</span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content">Yes, you can track up to 25 TCS tracking numbers in a single email.
          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>


        <details>
	        <summary>
            <span className="summary-title">How should I format the tracking numbers when I track
multiple packages?</span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content">When providing your shipment tracking numbers in the body of the
email, make sure that you:
• Enter only one tracking number in one line; or
• Add an space between each tracking number; or
• Separate the tracking numbers with commas
          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>

        <details>
	        <summary>
            <span className="summary-title">What does ‘Returned to Shipper’ mean?</span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content">The status ‘Returned to Shipper’ in the tracking summary means that the
shipment was returned to the original shipper. Possible reasons for
return include but are not limited to: shipment refused by the intended
consignee, physical address not found by TCS, or multiple failed delivery
attempts.

          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>


        <details>
	        <summary>
            <span className="summary-title">How will TCS respond in constantly changing
circumstances, such as a pandemic?</span>
            <div className="summary-chevron-up">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
            </div>
	        </summary>

          <div className="summary-content">Bound by the laws of the state, TCS strictly operates according to the
instructions issued by the government and law enforcement agencies. In
case of an emergency, or health crisis, we take all necessary precautions
and measures advised by the authorities and responsible organisations
such as the World Health Organisation (WHO). During the COVID-19
crisis, our teams have developed extraordinary capabilities and
comprehensive contingency plans to ensure a smooth running of
operations and deliveries in an unforeseeable event.

          </div>

          <div className="summary-chevron-down">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg>
          </div>

        </details>

        </div>
        </div>

        
   
      </div>
    </div>

    );
};
export default MobileFaqs;